import DisclosureEx from "@components/DisclosureEx";
import React, {useContext} from "react";
import {IconBug} from "@tabler/icons-react";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {PresenzeContext} from "@commons/hooks/usePresenze";
import {LavoratorePresenzeProprietaULRecord} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {DateTime} from "luxon";
import LogFlex from "./LogFlex";
import {PresenzeFormValues} from "../FormDataUpdater";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";

interface OpzioniGiornataProps {
    day: PresenzeFormValues,
    lavoratore: LavoratorePresenzeRecord,
    updCycle: number,
}

const LogGiornata: React.FC<OpzioniGiornataProps> = ({day, lavoratore, updCycle}) => {


    const {consolidatedData, periodo, ...context} = useContext(PresenzeContext);
    const {elencoTurni: turni, tabFlex, tabQualificaEcc, tabQuantificaEcc} = consolidatedData!;

    const proprietaGestione = LavoratorePresenzeRecord.getProprieta(lavoratore, DateTime.fromISO(day.dtGiornata!));

    const turnoDay = turni.find(turno => turno.codTurno === day.codTurno);
    const distribuzioneDay = turnoDay ? turnoDay.distribuzione[day.idGiorno - 1] : null;

    const showScattiOrdinati: boolean = updCycle > 0; //updCycle è >0 se è stato eseguito almeno un calcolo della giornata!

    return (
        <DisclosureEx accordionColor="bg-[#235f6a] hover:bg-[#1b4952] text-white" accordionTitle="Log" icon={<IconBug className="w-4 h-4"/>} accordionState={false}>
            <div className="text-elemPresenze text-[11px]">
                <div className="grid grid-cols-5 grid-rows-4 gap-1.5">
                    <div>Distribuzione</div>
                    <div className="col-span-4 font-bold">
                        {distribuzioneDay && <div className="inline-flex" dangerouslySetInnerHTML={{
                            __html: TurnoDistribuzioneRecord.getDistribuzioneDescrizione(distribuzioneDay)
                        }}/>}
                        {!distribuzioneDay && <span>--</span>}
                    </div>

                    <div className="row-span-4">Proprietà presenze</div>
                    <div className="grid grid-rows-subgrid row-span-4 col-span-4">
                        <div className="gap-x-2 inline-flex">
                            <div className="w-1/4">Tipologia gestione:</div>
                            <div className="w-1/4 font-bold text-wrap">{LavoratorePresenzeProprietaULRecord.getDescTipologiaGestione(proprietaGestione)}</div>
                            <div className="w-1/4">Quantità timbrature:</div>
                            <div className="w-1/4 font-bold text-wrap">{LavoratorePresenzeProprietaULRecord.getDescQuantitaTimb(proprietaGestione)}</div>
                        </div>
                        {/*<div className="gap-x-2 inline-flex">
                            <div className="w-1/4">Tab. alternativi:</div>
                            <div className="w-1/4 font-bold text-wrap">{}</div>
                            <div className="w-1/4">Tab. giust. ricorr.:</div>
                            <div className="w-1/4 font-bold text-wrap">{}</div>
                        </div>*/}
                        <div className="gap-x-2 inline-flex">
                            <div className="w-1/4">Quantificazione eccedenze:</div>
                            <div className="w-1/4 font-bold text-wrap">{tabQuantificaEcc ? tabQuantificaEcc.descrizione : '--'}</div>
                            <div className="w-1/4">Qualificazione eccedenze:</div>
                            <div className="w-1/4 font-bold text-wrap">{tabQualificaEcc ? tabQualificaEcc.descrizione : '--'}</div>
                        </div>
                        <div className="gap-x-2 inline-flex">
                            <div className="w-1/4">Flessibilità:</div>
                            <div className="w-1/4 font-bold text-wrap">{tabFlex ? tabFlex.descrizione : '--'}</div>
                            {/*<div className="w-1/4">Tolleranza:</div>
                            <div className="w-1/4 font-bold text-wrap">{}</div>*/}
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-subgrid mt-3">
                    <LogFlex fieldName="scartiPrima" labelRowTimbrature="Scarti prima"/>
                    <LogFlex fieldName="scartiDopo" labelRowTimbrature="Scarti dopo" showLabels={false}/>
                    {showScattiOrdinati && <LogFlex fieldName="scartiOrdinati" labelRowTimbrature="" showLabels={false}/>}
                </div>

                <div className="grid grid-cols-5 gap-1.5">
                    <div className="col-start-2 col-span-1 inline-flex">
                        <div className="w-1/2">Overflow:</div>
                        <div className="w-1/2 font-bold">{/* flexOverflow */}</div>
                    </div>
                    <div className="col-start-3 col-span-1 inline-flex">
                        <div className="w-1/2">Tot. flex negativa:</div>
                        <div className="w-1/2 font-bold">{/* totaleFlexNegativo */}</div>
                    </div>
                    <div className="col-start-4 col-span-1 inline-flex">
                        <div className="w-1/2 underline">Saldo flex:</div>
                        <div className="w-1/2 font-bold">{/* totaleFlexPositivo */}</div>
                    </div>
                </div>

                <div className="grid grid-cols-subgrid mt-3">
                    <LogFlex fieldName="scartiDopo" labelRowTimbrature="Scarti flex ordinati" showLabels={false}/>{/* TODO cambiare name */}
                    {/*<LogFlex fieldName="scartiDopo" labelRowTimbrature="Effettive flex" showLabels={false}/> {/!* TODO cambiare name *!/} */}

                </div>
            </div>
        </DisclosureEx>
    )
}
export default LogGiornata;